import { LessonType, PersonType } from "@hubcapp/types";

export const lessonTypeToPersonType = (lessonType?: LessonType): PersonType => {
  switch (lessonType) {
    case LessonType.Dit:
      return PersonType.Dit;
    case LessonType.Motability:
      return PersonType.Motability;
    default:
      return PersonType.Learner;
  }
};
